import { FileUploader, SelectBox } from 'devextreme-react';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import * as ExcelJS from 'exceljs';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import {
    Button,
    Card,
    CardBody,
    Form,
    FormGroup,
    Input,
    Label,
    Nav,
    NavItem,
    NavLink,
} from 'reactstrap';
import Breadcrumb from '../../components/common/breadcrumb';
import api from '../../services/api-configuration';
import { ButtonOnExporting } from '../../utils/DataGridExporter';
import './veri-iptali.scss';

const VeriIptali = () => {
    const [activeTab, setActiveTab] = useState('excel');
    const [chassisNumber, setChassisNumber] = useState('');
    const [selectedModule, setSelectedModule] = useState('');
    const [file, setFile] = useState(null);
    const [modules, setModules] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [excelError, setExcelError] = useState('');
    const [errorArray, setErrorArray] = useState([]);
    const [warningsArray, setWarningsArray] = useState([]);
    const fileUploaderRef = useRef(null);
    const errorGridRef = useRef(null);
    const warningsGridRef = useRef(null);

    // Common styles
    const labelStyle = {
        fontWeight: 500,
        color: '#212529',
        fontSize: '0.9rem',
        marginBottom: '0.5rem'
    };

    const containerStyle = {
        backgroundColor: '#f8f9fa',
        padding: '15px',
        border: '1px solid #dee2e6'
    };

    const tableHeaderStyle = {
        fontWeight: 500,
        fontSize: '0.9rem',
        color: '#212529',
        padding: '12px'
    };

    const tableCellStyle = {
        fontSize: '0.9rem',
        padding: '12px'
    };

    const buttonStyle = {
        padding: '8px 16px',
        fontSize: '0.9rem',
        fontWeight: 500,
        height: '38px'
    };

    useEffect(() => {
        fetchCancellableModules();
    }, []);

    const fetchCancellableModules = async () => {
        try {
            setIsLoading(true);
            const response = await api.post('/cancelOrderResponse');
            if (response.data) {
                const formattedModules = response.data.map(module => ({
                    id: module.order_name,
                    text: module.order_turkish
                }));
                setModules(formattedModules);
            } else {
                toast.error('İptal edilebilecek modüller getirilemedi');
            }
        } catch (error) {
            console.error('Error fetching cancellable modules:', error);
            toast.error('İptal edilebilecek modüller getirilirken bir hata oluştu');
        } finally {
            setIsLoading(false);
        }
    };

    const validateExcelFile = async (file) => {
        try {
            const workbook = new ExcelJS.Workbook();
            await workbook.xlsx.load(file);

            const worksheet = workbook.worksheets[0];
            if (!worksheet) {
                setExcelError('Excel dosyası boş veya geçersiz');
                return false;
            }

            const headerRow = worksheet.getRow(1);
            const headers = headerRow.values.filter(Boolean);

            if (headers.length !== 1) {
                setExcelError('Excel dosyasında sadece 1 kolon (sase) olmalıdır');
                return false;
            }

            if (headers[0].toLowerCase() !== 'sase') {
                setExcelError('Excel dosyasının ilk kolonu "sase" olmalıdır');
                return false;
            }

            setExcelError('');
            return true;
        } catch (error) {
            console.error('Error validating Excel file:', error);
            setExcelError('Excel dosyası okunurken bir hata oluştu');
            return false;
        }
    };

    const handleFileChange = async (e) => {
        if (e.value && e.value.length > 0) {
            const selectedFile = e.value[0];
            const isValid = await validateExcelFile(selectedFile);
            if (isValid) {
                setFile(selectedFile);
            } else {
                setFile(null);
            }
        } else {
            setFile(null);
            setExcelError('');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!file || !selectedModule) return;

        try {
            setIsLoading(true);
            const formData = new FormData();
            formData.append('file', file);
            formData.append('user_id', parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')));
            formData.append('delete', 'DELETE');
            formData.append('process_type', selectedModule);

            const response = await api.post('/vehicle/add', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.data.success) {
                let errors = [];
                let warnings = [];
                let successCount = 0;

                // Hata mesajını Türkçeye çeviren fonksiyon
                const translateErrorMessage = (message) => {
                    console.log('Çevrilecek mesaj:', message);
                    console.log('Modules array:', modules);

                    if (!message) return 'Bilinmeyen hata';

                    // "no PROCESS_TYPE data found for chassis CHASSIS_NO" formatını kontrol et
                    if (message.includes('data found for chassis')) {
                        console.log('Mesaj format eşleşti');
                        const processTypeMatch = message.match(/no (\w+) data found/);
                        console.log('Process type match:', processTypeMatch);

                        if (processTypeMatch && processTypeMatch[1]) {
                            const processType = processTypeMatch[1];
                            console.log('Bulunan process type:', processType);

                            const moduleData = modules.find(m => m.id === processType);
                            console.log('Bulunan module data:', moduleData);

                            if (moduleData) {
                                // Chassis numarasını çıkar
                                const chassisMatch = message.match(/chassis (\w+)/);
                                const chassisNo = chassisMatch ? chassisMatch[1] : '';
                                const translatedMessage = `${chassisNo} şase numarası için ${moduleData.text} verisi bulunamadı`;
                                console.log('Çevrilmiş mesaj:', translatedMessage);
                                return translatedMessage;
                            } else {
                                console.log('Module data bulunamadı, orijinal mesaj döndürülüyor');
                            }
                        }
                    } else {
                        console.log('Mesaj format eşleşmedi');
                    }

                    // Diğer mesajları olduğu gibi bırak
                    console.log('Orijinal mesaj döndürülüyor:', message);
                    return message;
                };

                response.data.results.forEach((result) => {
                    if (result.success !== true) {
                        // Başarısız olan kayıtları error olarak ekle
                        errors.push({
                            chassis_no: result.chassis_no,
                            message: translateErrorMessage(result.message || result.error || 'Bilinmeyen hata')
                        });
                    } else if (result.success === true) {
                        // Başarılı kayıtları say
                        successCount++;

                        // Başarılı olsa da uyarı mesajı varsa warnings'e ekle
                        if (result.warnings) {
                            warnings.push({
                                chassis_no: result.chassis_no,
                                message: result.warnings?.join(" 🔷 ")?.replaceAll("not found for brand", "seçili marka için bulunamadı: ").replaceAll("Brand", "Marka").replaceAll("not found in system", " sistemde tanımlı değil").replaceAll("color", "Renk")
                            });
                        }
                        if (result.warning) {
                            if (result.warning.info && result.warning.date) return;
                            warnings.push({
                                chassis_no: result.chassis_no,
                                message: result.warning
                            });
                        }
                    }
                });

                setErrorArray(errors);
                setWarningsArray(warnings);

                let message = '';
                const failedCount = errors.length;

                if (successCount > 0) {
                    message += `${successCount} adet başarılı`;
                }
                if (failedCount > 0) {
                    message += message ? `, ${failedCount} adet hatalı` : `${failedCount} adet hatalı`;
                }
                if (warnings.length > 0) {
                    message += message ? `, ${warnings.length} adet uyarılı` : `${warnings.length} adet uyarılı`;
                }
                message += ' kayıt';

                if (failedCount === 0 && warnings.length === 0) {
                    toast.success(successCount + " adet kayıt başarılı bir şekilde işlendi.");
                    handleClear();
                } else if (failedCount > 0) {
                    toast.error(message);
                } else if (warnings.length > 0) {
                    toast.warning(message);
                }
            } else {
                toast.error(response.data.error || 'İşlem başarısız oldu');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            const errorMessage = error.response?.data?.error?.replace("dosya işlenirken hata: failed to transform data:", "") || 'İşlem sırasında bir hata oluştu';
            toast.error(errorMessage);
            setErrorArray([{
                chassis_no: "GENEL HATA",
                message: errorMessage
            }]);
        } finally {
            setIsLoading(false);
        }
    };

    const handleClear = () => {
        setFile(null);
        setSelectedModule('');
        setExcelError('');
        setErrorArray([]);
        setWarningsArray([]);
        if (fileUploaderRef.current) {
            fileUploaderRef.current.instance.reset();
        }
    };

    const renderResultGrid = (data, ref, title, color) => {
        if (!data || data?.length === 0) return null;

        return (
            <div className="space-y-4 mt-4">
                <div className="d-flex justify-content-between align-items-center">
                    <span className="font-bold" style={{ color, fontWeight: 500, fontSize: '0.9rem' }}>
                        <b> {title} ({data.length})</b>
                    </span>
                    <Button
                        className="btn btn-success"
                        style={{ height: "32px", fontSize: '0.75rem', padding: '4px 12px' }}
                        onClick={(e) => {
                            ButtonOnExporting(
                                e,
                                ref,
                                `Veri İptali - ${title} - ${moment(new Date()).format("DD/MM/YYYY")}`,
                                "Sayfa-1"
                            );
                        }}
                    >
                        <i className="fa fa-file-excel-o mr-1"></i>
                        Excel İndir
                    </Button>
                </div>
                <DataGrid
                    ref={ref}
                    dataSource={data}
                    showColumnHeaders={false}
                    filterRow={{ visible: false }}
                    showColumnLines={true}
                    showRowLines={true}
                    showBorders={true}

                >
                    <Column
                        dataField="chassis_no"
                        caption="Şase No"
                        alignment="center"
                        selectedFilterOperation="contains"
                        width={200}
                    />
                    <Column
                        dataField="message"
                        caption="Mesaj"
                        selectedFilterOperation="contains"
                        calculateDisplayValue={(e) => {
                            return e.message || "Bilinmeyen hata";
                        }}
                    />
                </DataGrid>
            </div>
        );
    };

    return (
        <div className="content-block p-0">
            <Breadcrumb current="Veri İptali" />

            <Card className="main-card" style={{ maxWidth: "100%" }}>
                <Nav tabs className="nav-tabs">
                    {/*  <NavItem>
                        <NavLink
                            className={activeTab === 'manual' ? 'active' : ''}
                            onClick={() => setActiveTab('manual')}
                        >
                            Manuel Giriş
                        </NavLink> 
                    </NavItem>*/}
                    <NavItem>
                        <NavLink
                            className={activeTab === 'excel' ? 'active' : ''}
                            onClick={() => setActiveTab('excel')}
                            style={{ padding: '10px 15px' }}
                        >
                            Excel Dosyası
                        </NavLink>
                    </NavItem>
                </Nav>

                <CardBody className='p-3'>
                    <Form onSubmit={handleSubmit}>
                        <div className="input-section p-2">
                            {activeTab === 'manual' ? (
                                <FormGroup>
                                    <Label className="form-label" style={labelStyle}>
                                        <strong>Şase Numarası</strong>
                                    </Label>
                                    <Input
                                        type="text"
                                        value={chassisNumber}
                                        onChange={(e) => setChassisNumber(e.target.value)}
                                        placeholder="Şase numarası giriniz"
                                        className="form-input"
                                        required={activeTab === 'manual'}
                                        style={{
                                            border: '1px solid #ced4da',
                                            padding: '8px 12px',
                                            fontSize: '0.9rem',
                                            height: '38px'
                                        }}
                                    />
                                </FormGroup>
                            ) : (
                                <FormGroup>
                                    <div className="text-muted mt-2" style={{
                                        fontSize: '0.85rem',
                                        backgroundColor: '#f8f9fa',
                                        padding: '8px 12px',
                                        border: '1px solid #dee2e6',
                                        marginBottom: '1rem'
                                    }}>
                                        <i className="fa fa-info-circle mr-2"></i>
                                        Not: Excel dosyasında sadece <strong>"sase"</strong> kolonu bulunmalıdır.
                                    </div>
                                    <Label className="form-label" style={labelStyle}>
                                        <strong>Excel Dosyası</strong>
                                    </Label>
                                    <div className="upload-container" style={{ ...containerStyle, minHeight: '120px' }}>
                                        <FileUploader
                                            ref={fileUploaderRef}
                                            selectButtonText="Dosya Seç"
                                            labelText="veya buraya sürükleyin"
                                            multiple={false}
                                            accept=".xlsx,.xls"
                                            uploadMode="useForm"
                                            onValueChanged={handleFileChange}
                                        />
                                    </div>

                                    {excelError && (
                                        <div className="text-danger mt-2" style={{
                                            backgroundColor: '#f8f9fa',
                                            padding: '8px 12px',
                                            border: '1px solid #dee2e6',
                                            fontSize: '0.85rem',
                                            marginTop: '0.5rem'
                                        }}>
                                            <i className="fa fa-exclamation-circle mr-2"></i>
                                            {excelError}
                                        </div>
                                    )}
                                </FormGroup>
                            )}

                            <FormGroup className="mt-4">
                                <Label className="form-label" style={labelStyle}>
                                    <strong>Modül Seçiniz</strong>
                                </Label>
                                <div style={{ ...containerStyle, minHeight: '120px' }}>
                                    <SelectBox
                                        dataSource={modules}
                                        displayExpr="text"
                                        valueExpr="id"
                                        value={selectedModule}
                                        onValueChanged={(e) => setSelectedModule(e.value)}
                                        placeholder="Modül seçiniz"
                                        searchEnabled={true}
                                        className="form-select"
                                        disabled={isLoading}
                                    />
                                </div>
                            </FormGroup>

                            {(errorArray.length > 0 || warningsArray.length > 0) && (
                                <div className="mt-4">
                                    {renderResultGrid(errorArray, errorGridRef, "Hatalı İşlemler", "#dc3545")}
                                    {renderResultGrid(warningsArray, warningsGridRef, "Uyarılı İşlemler", "#ffc107")}
                                </div>
                            )}

                            <div className="form-actions d-flex justify-content-end gap-4 mt-4" style={{ paddingTop: '1rem', borderTop: '1px solid #dee2e6' }}>
                                <button
                                    type="button"
                                    onClick={handleClear}
                                    className="btn btn-danger mr-2"
                                    style={{
                                        ...buttonStyle,
                                        backgroundColor: '#f8f9fa',
                                        border: '1px solid #dee2e6',
                                        color: 'white'
                                    }}
                                >
                                    <i className="fa fa-trash mr-2"></i>
                                    Temizle
                                </button>
                                <button
                                    type="submit"
                                    disabled={!file || !selectedModule || isLoading}
                                    className="btn btn-info"
                                    style={{
                                        ...buttonStyle,
                                        backgroundColor: '#0d6efd',
                                        border: '1px solid #0d6efd',
                                        color: 'white',
                                        opacity: (!file || !selectedModule || isLoading) ? 0.5 : 1,
                                        cursor: (!file || !selectedModule || isLoading) ? 'not-allowed' : 'pointer'
                                    }}
                                >
                                    {isLoading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                            İşleniyor...
                                        </>
                                    ) : (
                                        <>
                                            <i className="fa fa-save mr-2"></i>
                                            Kaydet
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </Form>
                </CardBody>
            </Card>
        </div>
    );
};

export default VeriIptali;